const getReadyReaderProductFeatures = (variantTypeDetails)=>{
    const { hasBlueFilter  } = variantTypeDetails;
    const productFeatures = [];
    if (!!hasBlueFilter) {
        productFeatures.push({
            type: 'blueLight',
            iconName: 'blueFilter',
            labelKey: 'products.readyreaders.features.blueFilter'
        });
    }
    return productFeatures;
};

export { getReadyReaderProductFeatures };
//# sourceMappingURL=get-ready-reader-product-features.js.map
